import { type BaseOptionType } from "antd/lib/select"

/**
 * The refusal a Won transition answers with when Settings > Configurations'
 * "Automatic Project Creation From Lead" is on and no Project Manager was
 * chosen: the lead is about to become a project, so the user is asked for its
 * PM (from the list the server sends) and the transition is retried with it.
 * Only returned to requests that opt in with `prompt_project_manager`.
 */
const PROJECT_MANAGER_REQUIRED = "project_manager_required"

interface ProjectManagerRequired {
  type: typeof PROJECT_MANAGER_REQUIRED
  projectManagers: BaseOptionType[]
}

const readProjectManagerRequired = (
  details: unknown
): ProjectManagerRequired | null => {
  const payload = details as
    | { type?: unknown; project_managers?: unknown }
    | null
    | undefined
  if (payload?.type !== PROJECT_MANAGER_REQUIRED) return null
  return {
    type: PROJECT_MANAGER_REQUIRED,
    projectManagers: Array.isArray(payload.project_managers)
      ? (payload.project_managers as BaseOptionType[])
      : []
  }
}

export { PROJECT_MANAGER_REQUIRED, readProjectManagerRequired }
export type { ProjectManagerRequired }
